import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function ProofSection() {
  return <section className="bg-navy text-white-soft py-20 px-6 text-center" data-id="element-223">
      <div className="max-w-3xl mx-auto" data-id="element-224">
        <ShieldCheck className="w-20 h-20 text-gold mx-auto mb-8 opacity-90" data-id="element-225" />
        <h2 className="text-3xl md:text-4xl font-bold mb-8 font-serif leading-tight" data-id="element-226">
          De la angustia a la tranquilidad absoluta en 7 días
        </h2>
        <p className="text-xl md:text-2xl text-gray-300 leading-relaxed font-light" data-id="element-227">
          En tan solo 7 días, pasarás de la angustia de "¿qué pasará con mis
          cosas?" a la tranquilidad absoluta de saber que tu familia tiene un
          mapa claro. No es una promesa de software; es un cambio de identidad
          de "propietario digital confundido" a{' '}
          <strong className="text-gold font-bold" data-id="element-228">
            "protector familiar organizado"
          </strong>
          .
        </p>
      </div>
    </section>;
}